import styled from "styled-components";

export const MapContainerStyle = styled.div`
  display: block;
  height: 246px;
  border-radius: 10px;
  overflow: hidden;
`;

export const LoadingText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: ${({ theme }) => theme.colors.secondary};
`;